import { configureStore } from '@reduxjs/toolkit';
import orderDetailsReducer from './reducers/orderDetailsReducer';
import doneOrdersReducer from './reducers/orders/doneOrdersReducer';
import myOrdersReducer from './reducers/orders/myOrdersReducer';
import newOrderReducer from './reducers/orders/newOrderReducer';
import newServiceOrder from './reducers/orders/newServiceOrderReducer';
import unapprovedReducer from './reducers/orders/unapprovedReducer';
import userData from './reducers/userDataReducer';
import allOrdersReducer from './reducers/workQueue/allOrdersReducer';
import { api } from './rtk/api';

export const reducer = {
  [api.reducerPath]: api.reducer,
  [userData.name]: userData.reducer,
  [unapprovedReducer.name]: unapprovedReducer.reducer,
  [myOrdersReducer.name]: myOrdersReducer.reducer,
  [allOrdersReducer.name]: allOrdersReducer.reducer,
  [doneOrdersReducer.name]: doneOrdersReducer.reducer,
  [newOrderReducer.name]: newOrderReducer.reducer,
  [newServiceOrder.name]: newServiceOrder.reducer,
  [orderDetailsReducer.name]: orderDetailsReducer.reducer,
};

const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(api.middleware),
});

export default store;
